const CallButton = ({phone, disabled}: ICallButtonProps) => {
  return (
    <>
      {disabled ? (
        <div className=" text-center w-full border border-gray-300 rounded-md text-gray-300 py-4">
          <span className="icon-phone-call text-gray-300 mx-1"></span>
          تماس با فروشنده
        </div>
      ) : (
        <a
          href={`tel:${phone}`}
          className=" text-center w-full border border-primary rounded-md text-primary py-4"
        >
          <span className="icon-phone-call mx-1"></span>
          تماس با فروشنده
        </a>
      )}
    </>
  );
};

export default CallButton;
